import { combineReducers } from 'redux';

// Reducers
import tileReducer from './tileReducer';
import articleReducer from './articleReducer';
import globalsReducer from './globalsReducer';
import navReducer from './navReducer';
import footerReducer from './footerReducer';
import loaderReducer from './loaderReducer';
import ambassadorsReducer from './ambassadorsReducer';
import imagePlayerReducer from './imagePlayerReducer';

// Combine Reducers
const reducers = combineReducers({
  tilesState: tileReducer,
  globalsState: globalsReducer,
  navState: navReducer,
  footerState: footerReducer,
  loaderState: loaderReducer,
  articleState: articleReducer,
  ambassadorsState: ambassadorsReducer,
  imagePlayerState: imagePlayerReducer,
});

export default reducers;



// WEBPACK FOOTER //
// ./frontend/js/Base/Reducers/index.jsx